<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { SocialVariant, Variant } from '@centerhealth/fe/center-kit';
  import { addDataAttrs, IHeapEvent } from '@centerhealth/fe/heap';

  // strips off all default box element styles
  export let removeDefaultStyles = false;
  const strip = removeDefaultStyles ? 'strip' : '';

  export let variant: SocialVariant | Variant = 'primary';
  // for more external styling
  export let style = '';
  // adding html div element as a default value
  export let ref = '';
  // for more external tailwind styling
  export let customClass = '';
  const dispatch = createEventDispatcher();
  /**
   * Optional click handler
   */
  function onClick(): void {
    dispatch('click');
  }

  export let heapAttr: IHeapEvent = null;
</script>

<div
  {ref}
  use:addDataAttrs={heapAttr}
  class={['p-3', 'card', `card--${variant}`, customClass, strip].join(' ')}
  {style}
  on:click={onClick}
>
  <slot />
</div>

<style lang="postcss">
  .card {
    border-radius: 20px;
  }
  /* variant */
  .card--light {
    border: 0.5px solid #f0f0f0;
    @apply rounded-2xl;
    box-shadow: 0px 22px 44px -3px rgba(176, 212, 255, 0.25);
  }
  .card--primary {
    box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
  }
  .card--secondary {
    border-width: 3px;
    @apply border-solid;
    border-color: #eee;
  }
  .card--tertiary {
    border-width: 3px;
    @apply border-solid border-blue;
  }

  .card--email {
    border-width: 2px;
    @apply border-gray-lighter bg-white;
  }
  .card--instagram {
    @apply bg-instagram border-transparent;
  }
  .card--instagram:hover {
    background-color: lighten(#e95950, 10%);
  }
  .card--facebook {
    @apply bg-facebook border-transparent;
  }

  .card--faq {
    @apply bg-twitter border-transparent;
  }

  .strip {
    @apply border-none p-0 m-0;
  }
</style>
